<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.name')}}</label>
              <el-form-item prop="LocationName">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.LocationName.value"
                  maxlength="100"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.forma_envio')}}</label>
              <el-form-item prop="SendType">
                <el-select class="w-full" 
                  v-model="form.SendType.value" 
                  filterable
                  clearable :placeholder="$t('app.select')">
                    <el-option
                      v-for="opt in tiposFormasEnvio"
                      :key="opt.id"
                      :label="opt.name"
                      :value="opt.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('address.location') }}</label>
              <el-form-item prop="Address">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Address.value"
                  maxlength="60"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('address.pais') }}</label>
              <el-form-item prop="CountryCode">
                <el-select class="w-full" 
                  v-model="form.CountryCode.value" 
                  filterable
                  clearable :placeholder="$t('app.select')">
                    <el-option
                      v-for="opt in listPaises"
                      :key="opt.key"
                      :label="opt.name"
                      :value="opt.id">
                  </el-option>
                </el-select>
               </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('address.codigo_postal') }}</label>
              <el-form-item prop="PostCode">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.PostCode.value"
                  maxlength="60"
                  type="number"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('address.provincia') }}</label>
              <el-form-item prop="Province">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Province.value"
                  maxlength="60"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('address.poblacion') }}</label>
              <el-form-item prop="Town">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Town.value"
                  maxlength="60"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$tc('users.email', 1)}}</label>
              <el-form-item prop="ElectronicMail">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.ElectronicMail.value"
                  maxlength="60"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.TeleFax') }}</label>
              <el-form-item prop="TeleFax">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.TeleFax.value"
                  maxlength="60"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('address.telefono') }}</label>
              <el-form-item prop="Telephone">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Telephone.value"
                  maxlength="60"
                  type="number"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.WebAddress') }}</label>
              <el-form-item prop="WebAddress">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.WebAddress.value"
                  maxlength="60"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.entity_name_plural') }}</label>
              <el-form-item prop="ContactPersons">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.ContactPersons.value"
                  maxlength="60"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('administrativecenter.cno_cnae') }}</label>
              <el-form-item prop="CnoCnae">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.CnoCnae.value"
                  maxlength="60"
                />
              </el-form-item>
            </div>
            
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('administrativecenter.INE_town_code') }}</label>
              <el-form-item prop="INETownCode">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.INETownCode.value"
                  maxlength="60"
                />
              </el-form-item>
            </div>
            
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('administrativecenter.additional_details') }}</label>
              <el-form-item prop="AdditionalDetails">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.AdditionalDetails.value"
                  maxlength="60"
                />
              </el-form-item>
            </div>
            
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('companies.configuration_rec.dire') }}</label>
              <el-form-item prop="DIRE">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.DIRE.value"
                  maxlength="60"
                />
              </el-form-item>
            </div>
            
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.name') }}</label>
              <el-form-item prop="Name">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Name.value"
                  maxlength="60"
                />
              </el-form-item>
            </div>
            
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    },
    vuexnamespace: {
      type: String,
      default: 'none',
    },
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      isOpen: this.panelOpen,
      form: {
        LocationName: { label: i18n.t('app.name'), value: '' },
        SendType: { label: i18n.t('app.forma_envio'), value: '' },
        Address: { label: i18n.t('address.location'), value: '' },
        CountryCode: { label: i18n.t('address.pais'), value: '' },
        PostCode: { label: i18n.t('address.codigo_postal'), value: '' },
        Province: { label: i18n.t('address.provincia'), value: '' },
        Town: { label: i18n.t('address.poblacion'), value: '' },
        Telephone: { label: i18n.t('address.telefono'), value: '' },
        TeleFax: { label: i18n.t('contacto.TeleFax'), value: '' },
        WebAddress: { label: i18n.t('contacto.WebAddress'), value: '' },
        ElectronicMail: { label: i18n.tc('users.email', 1), value: '' },
        ContactPersons: { label: i18n.t('contacto.entity_name_plural'), value: '' },
        CnoCnae: { label: i18n.t('administrativecenter.cno_cnae'), value: '' },
        INETownCode: { label: i18n.t('administrativecenter.INE_town_code'), value: '' },
        AdditionalDetails: { label: i18n.t('administrativecenter.additional_details'), value: '' },
        DIRE: { label: i18n.t('companies.configuration_rec.dire'), value: '' },
        Name: { label: i18n.t('app.name'), value: '' },
      },
      loadingData: false,
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ]
    }
  },
  computed: {
    tiposFormasEnvio: function () {
      // Hay elementos duplicados 
      const sendType = new Set(this.$store.getters['config/TIPOS_PGE'].concat(this.$store.getters['config/TIPOS_PGE_RECEPCION']).map(JSON.stringify))
      return Array.from(sendType).map(JSON.parse)
    },
    listPaises: function () {
      return this.$store.getters['config/PAISES']
    },
  },
  mounted: async function () {
    // this.loadingData = true
    // const dataAgrupaciones = await getAgrupacionesNombreCompanies()
    // if (dataAgrupaciones.blnError === true) {
    //   this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataAgrupaciones))
    // }
    // this.listGrouping = dataAgrupaciones.Respuesta.map((x, i) => ({ key: i, label: x, value: x }))
    // this.loadingData = false
  },
  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.LocationName.value = _temp.LocationName !== undefined && _temp.LocationName.value !== '' ? _temp.LocationName.value : ''
        this.form.SendType.value = _temp.SendType !== undefined && _temp.SendType.value !== '' ? _temp.SendType.value : ''
        this.form.Address.value = _temp.Address !== undefined && _temp.Address.value !== '' ? _temp.Address.value : ''
        this.form.CountryCode.value = _temp.CountryCode !== undefined && _temp.CountryCode.value !== '' ? _temp.CountryCode.value : ''
        this.form.PostCode.value = _temp.PostCode !== undefined && _temp.PostCode.value !== '' ? _temp.PostCode.value : ''
        this.form.Province.value = _temp.Province !== undefined && _temp.Province.value !== '' ? _temp.Province.value : ''
        this.form.Town.value = _temp.Town !== undefined && _temp.Town.value !== '' ? _temp.Town.value : ''
        this.form.Telephone.value = _temp.Telephone !== undefined && _temp.Town.Telephone !== '' ? _temp.Telephone.value : ''
        this.form.TeleFax.value = _temp.TeleFax !== undefined && _temp.Town.TeleFax !== '' ? _temp.TeleFax.value : ''
        this.form.WebAddress.value = _temp.WebAddress !== undefined && _temp.Town.WebAddress !== '' ? _temp.WebAddress.value : ''
        this.form.ElectronicMail.value = _temp.ElectronicMail !== undefined && _temp.ElectronicMail.value !== '' ? _temp.ElectronicMail.value : ''
        this.form.ContactPersons.value = _temp.ContactPersons !== undefined && _temp.ContactPersons.value !== '' ? _temp.ContactPersons.value : ''
        this.form.CnoCnae.value = _temp.CnoCnae !== undefined && _temp.CnoCnae.value !== '' ? _temp.CnoCnae.value : ''
        this.form.INETownCode.value = _temp.INETownCode !== undefined && _temp.INETownCode.value !== '' ? _temp.INETownCode.value : ''
        this.form.AdditionalDetails.value = _temp.AdditionalDetails !== undefined && _temp.AdditionalDetails.value !== '' ? _temp.AdditionalDetails.value : ''
        this.form.DIRE.value = _temp.DIRE !== undefined && _temp.DIRE.value !== '' ? _temp.DIRE.value : ''
        this.form.Name.value = _temp.Name !== undefined && _temp.Name.value !== '' ? _temp.Name.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        LocationName: { label: i18n.t('app.name'), value: '' },
        SendType: { label: i18n.t('app.forma_envio'), value: '' },
        Address: { label: i18n.t('address.location'), value: '' },
        CountryCode: { label: i18n.t('address.pais'), value: '' },
        PostCode: { label: i18n.t('address.codigo_postal'), value: '' },
        Province: { label: i18n.t('address.provincia'), value: '' },
        Town: { label: i18n.t('address.poblacion'), value: '' },
        Telephone: { label: i18n.t('address.telefono'), value: '' },
        TeleFax: { label: i18n.t('contacto.TeleFax'), value: '' },
        WebAddress: { label: i18n.t('contacto.WebAddress'), value: '' },
        ElectronicMail: { label: i18n.tc('users.email', 1), value: '' },
        ContactPersons: { label: i18n.t('contacto.entity_name_plural'), value: '' },
        CnoCnae: { label: i18n.t('administrativecenter.cno_cnae'), value: '' },
        INETownCode: { label: i18n.t('administrativecenter.INE_town_code'), value: '' },
        AdditionalDetails: { label: i18n.t('administrativecenter.additional_details'), value: '' },
        DIRE: { label: i18n.t('companies.configuration_rec.dire'), value: '' },
        Name: { label: i18n.t('app.name'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    }
  }
}
</script>
